import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/"

const baseApi = () => {
  function getCustomer(data) {
      return Post(baseUrl + "getCustomers", data)
  }

  return {
      getCustomer
  }
}

export const customerApi = baseApi()